import { Box } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import { Logo } from '@assets/svgs';
import { Button } from '@components/button';
import composeTheme from '@theme/theme';

/**
 * Bare-bones public header for the Get Appointed experience (and its admin preview): just the LIO
 * logo and a single "Producer Login" action that sends an existing producer to the login page.
 * Deliberately not the full portal nav — this is a public, pre-appointment page.
 */
export const GetAppointedHeader = () => (
  <ThemeProvider theme={composeTheme('dark')}>
    <Box
      component='header'
      sx={{
        width: '100%',
        height: 72,
        flexShrink: 0,
        px: { xs: 2, sm: 3, md: 4 },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        background: (theme) => theme.palette.background.gradient,
      }}
    >
      <Logo aria-label='LIO' style={{ height: 44, width: 44 }} />
      {/* Single link-styled element: MUI renders the Button as an <a> when href is set (no nested
          button-in-anchor). Producer Login is a public pre-appointment nav, so a plain href is fine. */}
      <Button variant='contained' href='/login'>
        Producer Login
      </Button>
    </Box>
  </ThemeProvider>
);
